import { StyleSheet } from 'react-native';

import {
  extraLargeNegativeMarginBottomBox,
  mediumNegativeMarginTopBox,
  smallPaddingVerticalBox,
} from '../view-style';

export default StyleSheet.create({
  content: {
    width: '100%',
  },
  container: {
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '80%',
    zIndex: 1,
  },
  bottom: {
    ...mediumNegativeMarginTopBox,
  },
  top: {
    ...extraLargeNegativeMarginBottomBox,
  },
  container1: {
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  text: {
    zIndex: 2,
  },
  textContainer: {
    ...smallPaddingVerticalBox,
  },
});
